import React from 'react';

export default function PaymentIcon() {
  return (
    <svg
      className="svg-icon"
      width="46px"
      height="31px"
      viewBox="0 0 46 31"
      role="img"
      aria-labelledby="payment-icon-title"
    >
      <title id="payment-icon-title">Payment icon</title>
      <g stroke="none" strokeWidth="1" fill="none" fillRule="evenodd">
        <g fill="#19A6A8" fillRule="nonzero">
          <path d="M5.68434189e-14,12.6666364 L5.68434189e-14,24.6969091 C5.68434189e-14,28.1612727 2.77545313,30.9696364 6.19921875,30.9696364 L39.7409453,30.9696364 C43.1647109,30.9696364 45.9401641,28.1612727 45.9401641,24.6969091 L45.9401641,12.6666364 C45.9401641,12.0641818 45.4574336,11.5757273 44.8620391,11.5757273 L1.078125,11.5757273 C0.482730469,11.5757273 5.68434189e-14,12.0641818 5.68434189e-14,12.6666364 Z M11.470082,20.303 L8.59508203,20.303 C7.55307422,20.303 6.70836328,19.4482727 6.70836328,18.3939091 C6.70836328,17.3395455 7.55307422,16.4848182 8.59508203,16.4848182 L11.470082,16.4848182 C12.5120898,16.4848182 13.3568008,17.3395455 13.3568008,18.3939091 C13.3568008,19.4482727 12.5120898,20.303 11.470082,20.303 Z" />
          <path d="M45.9401641,6.66663636 L45.9401641,6.27272727 C45.9401641,2.80836364 43.1647109,-3.77475828e-14 39.7409453,-3.77475828e-14 L6.19921875,-3.77475828e-14 C2.77545313,-3.77475828e-14 5.68434189e-14,2.80836364 5.68434189e-14,6.27272727 L5.68434189e-14,6.66663636 C5.68434189e-14,7.26909091 0.482730469,7.75754545 1.078125,7.75754545 L44.8620391,7.75754545 C45.4574336,7.75754545 45.9401641,7.26909091 45.9401641,6.66663636 Z" />
        </g>
      </g>
    </svg>
  );
}
